import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TablesState,
  Table,
  TablesListData,
} from '../../types/tables.types';

const initialState: TablesState = {
  tables: [],
  selectedTable: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  schemaIdFilter: '',
};

const tablesSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTables: (state, action: PayloadAction<TablesListData>) => {
      state.tables = action.payload.tables;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedTable: (state, action: PayloadAction<Table | null>) => {
      state.selectedTable = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSchemaIdFilter: (state, action: PayloadAction<string>) => {
      state.schemaIdFilter = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedTable: (state) => {
      state.selectedTable = null;
    },
    addTable: (state, action: PayloadAction<Table>) => {
      state.tables.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateTable: (state, action: PayloadAction<Table>) => {
      const index = state.tables.findIndex((table) => table.id === action.payload.id);
      if (index !== -1) {
        state.tables[index] = action.payload;
      }
      if (state.selectedTable?.id === action.payload.id) {
        state.selectedTable = action.payload;
      }
    },
    deleteTable: (state, action: PayloadAction<string>) => {
      state.tables = state.tables.filter((table) => table.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedTable?.id === action.payload) {
        state.selectedTable = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setTables,
  setSelectedTable,
  setPage,
  setPageSize,
  setSearch,
  setSchemaIdFilter,
  clearError,
  clearSelectedTable,
  addTable,
  updateTable,
  deleteTable,
} = tablesSlice.actions;

export default tablesSlice.reducer;
